import { createFileRoute } from "@tanstack/react-router"

import { DefinitionsPage } from "@/components/terminal/definitions-page"

// Definitions in Home's center well, like Requests: the header and the left
// column stay, the detections rail collapses (Dhanur, 24 Oct 2026).
export const Route = createFileRoute("/_terminal/terminal/definitions")({
  staticData: { shellMode: "page" },
  component: DefinitionsPage,
})
